<template>
    <div :class="liquidItems.length && liquidItems.length < 2 ? 'site-section site-section--no-padding-bot' : 'site-section'">
        <div class="site-row">
            <div class="liquids-items__filter">
                <div class="filter-section filter-section--no-padding" v-if="liquids.length > 0">
                    <div class="filter-items">
                        <div class="filter-item filter-item--mw" v-if="liquids.length > 0">
                            <label class="sr-only"
                                for="liquidsFilter">{{ dictionaries.LiquidOptionDefault }}</label>
                            <select id="liquidsFilter" name="liquidsFilter" @change="filterChanged" :disabled="isLoading" v-model="liquid" class="filter-item__select">
                                <option value="All">{{dictionaries.LiquidOptionDefault}}</option>
                                <option :value="liquid.Key" v-for="(liquid, index) in liquids" v-if="liquid.Name">{{liquid.Name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="site-row" v-show="!liquidItems.length || liquidItems.length > 1">
            <div class="separator-item">
                <hr class="separator-item__hr" />
            </div>
        </div>
        <div class="liquids-section" v-show="liquidItems.length && liquidItems.length < 2">
            <div class="liquids-items">
                <div class="liquids-items__inner site-row">
                    <liquidItem v-for="liquidItem in liquidItems" :liquidItem="liquidItem" :key="liquidItem.Id" :dictionaries="dictionaries" :products="liquidItem.Products"></liquidItem>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LiquidItem from "./components/liquidItem.vue";
    import { bindRoute } from "./mixins/bindroute.js";

    const serviceUrl = "/umbraco/api/liquids/getliquids",
        defaultLiquid = "All";

    export default {
        name: "liquids",
        components: {
            LiquidItem
        },
        data() {
            return {
                dictionaries: [],
                liquids: [],
                liquidItems: [],
                isLoading: false
            };
        },
        created() {
            this.getLiquids();
        },
        mixins: [
            bindRoute({
                liquid: defaultLiquid
            })
        ],
        methods: {
            getLiquids() {
                var vm = this,
                    languageCode = $("html").attr("lang");
                vm.toggleSpinner(true);
                var object = {
                    languageCode: languageCode
                };
                if (this.liquid != defaultLiquid) {
                    object.liquid = this.liquid;
                }
                $.get(serviceUrl, object, function (response) {
                    vm.dictionaries = response.Dictionaries;
                    vm.liquids = response.Facets.Liquids;
                    vm.liquidItems.push(...response.Items);
                    vm.totalLiquids = response.TotalItems;
                }).fail(function (error) {
                    console.log(error);
                }).always(function () {
                    vm.toggleSpinner(false);
                });
            },
            toggleSpinner: function (isLoading) {
                this.isLoading = isLoading;
                if (isLoading) {
                    $("body").addClass("is-loading");
                } else {
                    $("body").removeClass("is-loading");
                }
            },
            filterChanged() {
                this.liquidItems = [];
                this.getLiquids();
            }
        }
    };
</script>